import debounce from 'lodash/debounce'
import { loadJsonApiEntities } from '../actions/loadJsonApiEntities'

const responseQueues = {}

export const debouncedFunc = (data) =>
  debounce(() => {
    window.dispatch(loadJsonApiEntities(data))
  }, 3000)

export const enqueueDelayedEntityResponse = ({ type, id, data }) => {
  if (!responseQueues[type]) {
    responseQueues[type] = {}
  }
  if (
    responseQueues[type][id] &&
    typeof responseQueues[type][id].cancel === 'function'
  ) {
    responseQueues[type].cancel()
  }

  responseQueues[type][id] = debouncedFunc(data)()
}
